import React, { useContext } from 'react';
import styles from "../../../../styles/pages/DocumentationPage/components/DocTabs/PostLead.module.css";
import { LangContext } from "../../../../context/LangContext";
import { ThemeContext } from "../../../../context/ThemeContext";

const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const translations = {
    ru: {
        title: "Получение лидов",
        requestInfoTitle: "Информация о запросе",
        urlLabel: "URL:",
        methodLabel: "Метод:",
        tokenLabel: "Ваш токен:",
        loading: "Загрузка...",
        error: "Ошибка",
        missing: "Отсутствует",
        requestParamsTitle: "Параметры запроса",
        tokenDesc: "Интеграционный токен.",
        emailDesc: "Поиск по email (частично, до 255 символов).",
        firstNameDesc: "Поиск по имени (частично, до 255 символов).",
        fromDateDesc: "Фильтр с даты (DD-MM-YYYY).",
        geosDesc: "Фильтр по гео. Допустимые значения: all, RU, SK, DK, LT, CZ, FR, LV, CY, NL, GE, HU, EE, GB, AT, FI, ME, KG, IE, PL, UA, PT, ES, MT, MC, NO, IT, IS, HR, GR, SE, BE, CH, DE, LU, US, HK, MY, UZ, PF, KG, AZ, AM, TJ.",
        idDesc: "Поиск по ID (точное совпадение, мин. 1).",
        lastNameDesc: "Поиск по фамилии (частично, до 255 символов).",
        orderByDesc: "Сортировка: ID_ASC, ID_DESC, NAME_ASC, NAME_DESC, PHONE_ASC, PHONE_DESC, EMAIL_ASC, EMAIL_DESC, REGISTRATION_DATE_ASC, REGISTRATION_DATE_DESC, COMPANY_ASC, COMPANY_DESC.",
        pageDesc: "Номер страницы (мин. 1, по умолчанию 1).",
        perPageDesc: "Лидов на странице (1-200, по умолчанию 10).",
        phoneDesc: "Поиск по телефону (частично, до 50 символов).",
        toDateDesc: "Фильтр до даты (DD-MM-YYYY).",
        curlTitle: "Пример запроса (cURL)",
        serverResponsesTitle: "Ответы сервера",
        successResponse: "Успешный запрос (200 OK)",
        unauthorizedToken: "Неверный токен (401 Unauthorized)",
        validationError: "Ошибка валидации (422 Unprocessable Entity)"
    },
    en: {
        title: "Get Leads",
        requestInfoTitle: "Request Information",
        urlLabel: "URL:",
        methodLabel: "Method:",
        tokenLabel: "Your Token:",
        loading: "Loading...",
        error: "Error",
        missing: "Missing",
        requestParamsTitle: "Request Parameters",
        tokenDesc: "Integration token.",
        emailDesc: "Search by email (partial, up to 255 characters).",
        firstNameDesc: "Search by first name (partial, up to 255 characters).",
        fromDateDesc: "Filter from date (DD-MM-YYYY).",
        geosDesc: "Filter by geo. Allowed values: all, RU, SK, DK, LT, CZ, FR, LV, CY, NL, GE, HU, EE, GB, AT, FI, ME, KG, IE, PL, UA, PT, ES, MT, MC, NO, IT, IS, HR, GR, SE, BE, CH, DE, LU, US, HK, MY, UZ, PF, KG, AZ, AM, TJ.",
        idDesc: "Search by ID (exact match, min. 1).",
        lastNameDesc: "Search by last name (partial, up to 255 characters).",
        orderByDesc: "Sorting: ID_ASC, ID_DESC, NAME_ASC, NAME_DESC, PHONE_ASC, PHONE_DESC, EMAIL_ASC, EMAIL_DESC, REGISTRATION_DATE_ASC, REGISTRATION_DATE_DESC, COMPANY_ASC, COMPANY_DESC.",
        pageDesc: "Page number (min. 1, default 1).",
        perPageDesc: "Leads per page (1-200, default 10).",
        phoneDesc: "Search by phone number (partial, up to 50 characters).",
        toDateDesc: "Filter to date (DD-MM-YYYY).",
        curlTitle: "Request Example (cURL)",
        serverResponsesTitle: "Server Responses",
        successResponse: "Successful Request (200 OK)",
        unauthorizedToken: "Invalid Token (401 Unauthorized)",
        validationError: "Validation Error (422 Unprocessable Entity)"
    },
};

export const GetLead = ({ affiliateToken, loading, error }) => {
    const { langSelected } = useContext(LangContext);
    const { theme } = useContext(ThemeContext);
    const t = translations[langSelected] || translations.ru;

    const mainContainerClass = `${styles.mainContainer} ${theme === 'dark' ? styles.darkMainContainer : ''}`;
    const cardClass = `${styles.card} ${theme === 'dark' ? styles.darkCard : ''}`;
    const cardTitleClass = `${styles.cardTitle} ${theme === 'dark' ? styles.darkCardTitle : ''}`;
    const infoLabelClass = `${styles.infoLabel} ${theme === 'dark' ? styles.darkInfoLabel : ''}`;
    const infoValueClass = `${styles.infoValue} ${theme === 'dark' ? styles.darkInfoValue : ''}`;
    const paramKeyClass = `${styles.paramKey} ${theme === 'dark' ? styles.darkParamKey : ''}`;
    const paramDescriptionClass = `${styles.paramDescription} ${theme === 'dark' ? styles.darkParamDescription : ''}`;
    const codeInlineClass = `${styles.codeInline} ${theme === 'dark' ? styles.darkCodeInline : ''}`;
    const responseGroupClass = `${styles.responseGroup} ${theme === 'dark' ? styles.darkResponseGroup : ''}`;
    const responseSubTitleClass = `${styles.responseSubTitle} ${theme === 'dark' ? styles.darkResponseSubTitle : ''}`;
    const tokenClass = `${styles.token} ${theme === 'dark' ? styles.darkToken : ''}`;

    return (
        <div className={mainContainerClass}>
            <h2 className={`${styles.title} ${theme === 'dark' ? styles.darkTitle : ''}`}>{t.title}</h2>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.requestInfoTitle}</h3>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.urlLabel}</span>
                    <span className={infoValueClass}>{API_BASE_URL}/integration/lead/leads</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.methodLabel}</span>
                    <span className={infoValueClass}>GET</span>
                </div>
                <div className={styles.infoItem}>
                    <span className={infoLabelClass}>{t.tokenLabel}</span>
                    <span className={tokenClass}>
                        {loading ? t.loading : error ? t.error : affiliateToken || t.missing}
                    </span>
                </div>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.requestParamsTitle}</h3>
                <ul className={styles.paramsList}>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>token</span>
                            <span className={styles.paramMeta}>(обязательный, string)</span>
                        </div>
                        <p className={paramDescriptionClass}>
                            {t.tokenDesc} Пример: <code className={codeInlineClass}>n8902n02ed902me02ec</code>
                        </p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>email</span>
                            <span className={styles.paramMeta}>(string, email)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.emailDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>first_name</span>
                            <span className={styles.paramMeta}>(string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.firstNameDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>from_date</span>
                            <span className={styles.paramMeta}>(string, date)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.fromDateDesc} Пример: <code className={codeInlineClass}>01-01-2025</code></p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>geos[]</span>
                            <span className={styles.paramMeta}>(array[string])</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.geosDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>id</span>
                            <span className={styles.paramMeta}>(integer)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.idDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>last_name</span>
                            <span className={styles.paramMeta}>(string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.lastNameDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>order_by</span>
                            <span className={styles.paramMeta}>(string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.orderByDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>page</span>
                            <span className={styles.paramMeta}>(number)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.pageDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>per_page</span>
                            <span className={styles.paramMeta}>(number)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.perPageDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>phone</span>
                            <span className={styles.paramMeta}>(string)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.phoneDesc}</p>
                    </li>
                    <li className={`${styles.paramItem} ${theme === 'dark' ? styles.darkParamItem : ''}`}>
                        <div className={styles.paramName}>
                            <span className={paramKeyClass}>to_date</span>
                            <span className={styles.paramMeta}>(string, date)</span>
                        </div>
                        <p className={paramDescriptionClass}>{t.toDateDesc} Пример: <code className={codeInlineClass}>01-01-2025</code></p>
                    </li>
                </ul>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.curlTitle}</h3>
                <pre className={styles.codeBlock}>
                    <code>
                        curl --request GET \<br />
                        --url 'https://api.domain.com/api/v1/integration/lead/leads?token=ytHRy4uTBFCuiILC&email=test@example.com&first_name=John' \<br />
                        --header 'Accept: application/json'
                    </code>
                </pre>
            </div>

            <div className={cardClass}>
                <h3 className={cardTitleClass}>{t.serverResponsesTitle}</h3>
                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.successResponse}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "data": [
        {
            "id": 1,
            "email": "email",
            "first_name": "First",
            "last_name": "Last",
            "phone": "09611499654",
            "sale_status": "New",
            "country": "Russia",
            "extra_info": "Russia",
            "geo": "all",
            "campaign": "Tesla",
            "created_at": "2025-01-01 00:00:00"
        }
    ],
    "meta": {
        "current_page": 1,
        "last_page": 10,
        "per_page": 15,
        "total": 100
    }
}`}
                        </code>
                    </pre>
                </div>

                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.unauthorizedToken}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "message": "Unauthorized"
}`}
                        </code>
                    </pre>
                </div>

                <div className={responseGroupClass}>
                    <h4 className={responseSubTitleClass}>{t.validationError}</h4>
                    <pre className={styles.responseBlock}>
                        <code>
                            {`{
    "message": "The email must be a valid email address.",
    "errors": {
        "email": [
            "The email must be a valid email address."
        ]
    }
}`}
                        </code>
                    </pre>
                </div>
            </div>
        </div>
    );
};
